<template>
  <p class="opc-price-bill-text-tips" :class="[mxIsSimplifyForProEdit ? 'opc-price-bill-text-tips-simplify' : '']">
    {{ $t(`billing.payment_tips`) }}
  </p>
</template>

<script>
import simplifyForProMixin from '@/plans/ZOOM_MEETING/mixin/simplify-for-pro.js';
export default {
  mixins: [simplifyForProMixin],
  name: 'PriceBillTextTips',
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils.scss';

.opc-price-bill-text-tips {
  color: var(--day-foreground-foreground-ada, #666487);
  @include darkTextColor2;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-bottom: 24px;
  &.opc-price-bill-text-tips-simplify {
    margin-top: 20px;
  }
}
</style>
